import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { Field, SelectFieldOptionsType } from '../../types';
import { SelectFieldView } from '../common';
import { SingleSelectFieldReadView } from './read-view';

export const SingleSelectField = ({
	id,
	label,
	value,
	onChange,
	formattedOptions,
	isInline,
	getValueContainer,
}: Field) => {
	const selectedOption: SelectFieldOptionsType | undefined = formattedOptions?.find(
		(option) => option.value === value,
	);

	const onSelection = (
		selection: SelectFieldOptionsType | null | undefined,
		analyticsEvent: UIAnalyticsEvent,
	) => {
		if (selection?.value === value) return;

		onChange({ value: selection?.value || '' }, analyticsEvent);
	};

	return (
		<SelectFieldView
			id={id}
			isMulti={false}
			label={label}
			value={selectedOption}
			valueAsString={value}
			options={formattedOptions}
			onSelection={onSelection}
			readView={() => (
				<SingleSelectFieldReadView
					value={value}
					getValueContainer={getValueContainer}
					inInlineEdit
				/>
			)}
			isInline={isInline}
		/>
	);
};

export { SingleSelectFieldReadView };
